import { createFileRoute } from '@tanstack/react-router';
import { Error } from '@/components/custom-error/custom-error';

export const Route = createFileRoute('/error')({
  component: Error,
});
